export type ValueOf<T> = T[keyof T];

export const BankTransactionType = Object.freeze({
  DEPOSIT: 0, //acconto
  BALANCE: 1 //saldo
});

export type BankTransactionTypeValues = ValueOf<typeof BankTransactionType>;
export type BankTransactionTypeKeys = keyof typeof BankTransactionType;


